<template>
	<div class="container">
		<div class="dashboard-header">
			<h2 class="h2">Olá {{ usuario }}</h2>
			<div class="action-buttons">
				<router-link to="/adicionar-usuario" class="btn btn-success">
					<i class="bi bi-person-plus-fill"></i> Adicionar usuário
				</router-link>
				<router-link to="/meu-perfil" class="btn btn-primary">
					<i class="bi bi-person-fill"></i> Meu Perfil
				</router-link>
			</div>
		</div>


		<div class="stats-cards">
			<div class="stat-card">
				<router-link :to="{ name: 'AdminExtratoMes' }" class="link">
					<h3>{{ estatisticasMeses.MesAtual }}</h3>
					<p>Total de leads no mês</p>
				</router-link>
			</div>
			<div class="stat-card">
				<h3>{{ estatisticasMeses.MesAnterior }}</h3>
				<p>Total mês anterior</p>
			</div>
		</div>
		<h2 class="h2">Scouters</h2>
		<div class="lista-scouters">
			<div class="box-scouter" v-for="(scouter, index) in scouters" :key="index">
				<router-link :to="{ path: `/extrato-scouter/${scouter.Id}`, query: { name: scouter.Nome } }"
					class="scouters">
					<img :src="imgProfile" class="img-profile" />
					<p class="nome-scouter">{{ scouter.Nome }}</p>
					<p class="scouter-leads-mes">
						<span class="leads-mes">{{ scouter.Quantidade }}</span>leads no mês
					</p>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { api } from "../services/api.js";
import imgProfile from "../assets/img/icon-profile.png";

const estatisticasMeses = ref([{}]);
const scouters = ref([{}]);
const usuario = ref('')

async function carregaScouter() {
	const res = await api.loadScouters();
	scouters.value = res.result
}

async function comparaMeses() {
	const res = await api.comparaMeses();
	estatisticasMeses.value = res.result[0];
}

onMounted(() => {
	usuario.value = JSON.parse(localStorage.getItem('usuario')).nome;
	carregaScouter();
	comparaMeses();
})
</script>
